import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarRef, MatSnackBarConfig} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  public success(message: string, action: string = 'Fechar'): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config,
      panelClass: ['success']
    });
  }

  public info(message: string, action: string = 'Fechar'): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config,
      panelClass: ['info']
    });
  }

  public warn(message: string, action: string = 'Fechar'): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config,
      panelClass: ['warn']
    });
  }

  public error(message: string, action: string = 'Fechar'): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config,
      panelClass: ['error']
    });
  }

  private config(): MatSnackBarConfig {
    return {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    }
  }
}
